export const SET_PENS = 'OVERVIEW::SET_PENS';
export function setPens(pens) {
    return {
        type: SET_PENS,
        pens,
    };
}

export const SET_BADGES = 'OVERVIEW::SET_BADGES';

export function setBadges(badges) {
    return {
        type: SET_BADGES,
        badges,
    };
}

export const SET_IS_LOADING = 'OVERVIEW::SET_IS_LOADING';
export function setIsLoading(isLoading) {
    return {
        type: SET_IS_LOADING,
        isLoading,
    };
}

export const OPEN_CATEGORIES = 'OVERVIEW::OPEN_CATEGORIES';
export function openCategories() {
    return {
        type: OPEN_CATEGORIES,
    };
}

export const CLOSE_CATEGORIES = 'OVERVIEW::CLOSE_CATEGORIES';
export function closeCategories() {
    return {
        type: CLOSE_CATEGORIES,
    };
}

export const SET_CATEGORY_FILTER = 'OVERVIEW::SET_CATEGORY_FILTER';
export function setCategoryFilter(categoryId) {
    return {
        type: SET_CATEGORY_FILTER,
        categoryId,
    };
}

export const SET_CURRENT_DISPLAY_LOCAL = 'OVERVIEW::SET_CURRENT_DISPLAY_LOCAL';

export function setCurrentDisplayLocale(displayLocale) {
    return {
        type: SET_CURRENT_DISPLAY_LOCAL,
        displayLocale,
    };
}

export const SET_ACTIVE_BADGES = 'OVERVIEW::SET_ACTIVE_BADGES';

export function setActiveBadges(activeBadges) {
    return {
        type: SET_ACTIVE_BADGES,
        activeBadges,
    };
}
